import { StarRating16 } from '@hagerty/icons';
import clsx from 'clsx';
import React from 'react';

import { RatingProps } from './Rating.types';

export const Rating = React.memo(
  ({
    isBackgroundDark = false,
    isNumericVisible = false,
    rating = '0',
    testid,
  }: RatingProps): JSX.Element => {
    const ratingForClass = rating.replace(/\.0?/, '-').replace(/-$/, '');

    return (
      <figure
        className={clsx(`rating rating__${ratingForClass}`, {
          'is-background-dark': isBackgroundDark,
        })}
        data-testid={testid}
      >
        <div className='rating__stars'>
          <StarRating16
            className='rating__stars-positive'
            width={undefined}
            height={undefined}
            preserveAspectRatio='xMinYMid slice'
            fill='#E6C005'
          />
          <StarRating16
            className='rating__stars-negative'
            width={undefined}
            height={undefined}
            preserveAspectRatio='xMaxYMid slice'
            fill='#6F757C'
          />
        </div>
        <figcaption
          className={clsx('rating__numeric', { 'sr-only': !isNumericVisible })}
        >
          <span className='sr-only'>Rated: </span>
          {rating}
          <span className='sr-only'> out of 5</span>
        </figcaption>
      </figure>
    );
  }
);
Rating.displayName = 'Rating';
